import CustomFontLoader from './font-loader.js';

(function() {
    // Use our custom font loader instead of FontFaceObserver
    var fontA = new CustomFontLoader('ITC Avant Garde Gothic W05 Md');
    var fontB = new CustomFontLoader('Avenir Next W05 Regular');
    var fontC = new CustomFontLoader('Avenir Next W05 Medium');

    Promise.all([
        fontA.load(), 
        fontB.load(),
        fontC.load()
    ]).then(function () {
    }).catch(function(err) {
        // Still publish the event even if fonts fail to load
        // to prevent UI from hanging
        console.warn('Some fonts failed to load:', err);
    });

})();
